// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInviteData, AcceptInviteErrors, AcceptInviteResponses, ChangeUserRoleData, ChangeUserRoleErrors, ChangeUserRoleResponses, CreateOrgData, CreateOrgErrors, CreateOrgResponses, DeactivateOrgData, DeactivateOrgErrors, DeactivateOrgResponses, DeactivateUserData, DeactivateUserErrors, DeactivateUserResponses, DownloadBatchErrorsData, DownloadBatchErrorsErrors, DownloadBatchErrorsResponses, DownloadBatchOutputData, DownloadBatchOutputErrors, DownloadBatchOutputResponses, DownloadFileData, DownloadFileErrors, DownloadFileResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GetBatchData, GetBatchErrors, GetBatchResponses, HealthData, HealthResponses, InviteUserData, InviteUserErrors, InviteUserResponses, ListBatchesData, ListBatchesResponses, ListOpenaiBatchesData, ListOpenaiBatchesErrors, ListOpenaiBatchesResponses, ListOrgsData, ListOrgsResponses, ListOrgUsersData, ListOrgUsersErrors, ListOrgUsersResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutErrors, LogoutResponses, ReactivateOrgData, ReactivateOrgErrors, ReactivateOrgResponses, ReactivateUserData, ReactivateUserErrors, ReactivateUserResponses, RefreshData, RefreshErrors, RefreshResponses, ResendInvitationData, ResendInvitationErrors, ResendInvitationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, RunPromptData, RunPromptErrors, RunPromptResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Login
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: '/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh
 */
export const refresh = <ThrowOnError extends boolean = false>(options?: Options<RefreshData, ThrowOnError>) => (options?.client ?? client).post<RefreshResponses, RefreshErrors, ThrowOnError>({ url: '/auth/refresh', ...options });

/**
 * Logout
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({ url: '/auth/logout', ...options });

/**
 * Forgot Password
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>) => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/auth/forgot-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Password
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>) => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Users
 */
export const listOrgUsers = <ThrowOnError extends boolean = false>(options: Options<ListOrgUsersData, ThrowOnError>) => (options.client ?? client).get<ListOrgUsersResponses, ListOrgUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/org/{org_id}',
    ...options
});

/**
 * Invite User
 */
export const inviteUser = <ThrowOnError extends boolean = false>(options: Options<InviteUserData, ThrowOnError>) => (options.client ?? client).post<InviteUserResponses, InviteUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Invitation
 */
export const resendInvitation = <ThrowOnError extends boolean = false>(options: Options<ResendInvitationData, ThrowOnError>) => (options.client ?? client).post<ResendInvitationResponses, ResendInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/invite/{invite_id}/resend',
    ...options
});

/**
 * Accept Invite
 */
export const acceptInvite = <ThrowOnError extends boolean = false>(options: Options<AcceptInviteData, ThrowOnError>) => (options.client ?? client).post<AcceptInviteResponses, AcceptInviteErrors, ThrowOnError>({
    url: '/users/accept-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate User
 */
export const deactivateUser = <ThrowOnError extends boolean = false>(options: Options<DeactivateUserData, ThrowOnError>) => (options.client ?? client).patch<DeactivateUserResponses, DeactivateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{user_id}/deactivate',
    ...options
});

/**
 * Reactivate User
 */
export const reactivateUser = <ThrowOnError extends boolean = false>(options: Options<ReactivateUserData, ThrowOnError>) => (options.client ?? client).patch<ReactivateUserResponses, ReactivateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{user_id}/reactivate',
    ...options
});

/**
 * Change User Role
 */
export const changeUserRole = <ThrowOnError extends boolean = false>(options: Options<ChangeUserRoleData, ThrowOnError>) => (options.client ?? client).patch<ChangeUserRoleResponses, ChangeUserRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{user_id}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Orgs
 */
export const listOrgs = <ThrowOnError extends boolean = false>(options?: Options<ListOrgsData, ThrowOnError>) => (options?.client ?? client).get<ListOrgsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orgs/',
    ...options
});

/**
 * Create Org
 */
export const createOrg = <ThrowOnError extends boolean = false>(options: Options<CreateOrgData, ThrowOnError>) => (options.client ?? client).post<CreateOrgResponses, CreateOrgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orgs/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate Org
 */
export const deactivateOrg = <ThrowOnError extends boolean = false>(options: Options<DeactivateOrgData, ThrowOnError>) => (options.client ?? client).patch<DeactivateOrgResponses, DeactivateOrgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orgs/{org_id}/deactivate',
    ...options
});

/**
 * Reactivate Org
 */
export const reactivateOrg = <ThrowOnError extends boolean = false>(options: Options<ReactivateOrgData, ThrowOnError>) => (options.client ?? client).patch<ReactivateOrgResponses, ReactivateOrgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/orgs/{org_id}/reactivate',
    ...options
});

/**
 * List Openai Batches
 */
export const listOpenaiBatches = <ThrowOnError extends boolean = false>(options?: Options<ListOpenaiBatchesData, ThrowOnError>) => (options?.client ?? client).get<ListOpenaiBatchesResponses, ListOpenaiBatchesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/openai-batches',
    ...options
});

/**
 * Run Prompt
 */
export const runPrompt = <ThrowOnError extends boolean = false>(options: Options<RunPromptData, ThrowOnError>) => (options.client ?? client).post<RunPromptResponses, RunPromptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/prompts/{prompt_id}/run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Batch
 */
export const getBatch = <ThrowOnError extends boolean = false>(options: Options<GetBatchData, ThrowOnError>) => (options.client ?? client).get<GetBatchResponses, GetBatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/batches/{batch_id}',
    ...options
});

/**
 * Download Batch Output
 */
export const downloadBatchOutput = <ThrowOnError extends boolean = false>(options: Options<DownloadBatchOutputData, ThrowOnError>) => (options.client ?? client).get<DownloadBatchOutputResponses, DownloadBatchOutputErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/batches/{batch_id}/output',
    ...options
});

/**
 * Download Batch Errors
 */
export const downloadBatchErrors = <ThrowOnError extends boolean = false>(options: Options<DownloadBatchErrorsData, ThrowOnError>) => (options.client ?? client).get<DownloadBatchErrorsResponses, DownloadBatchErrorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/batches/{batch_id}/errors',
    ...options
});

/**
 * Download File
 */
export const downloadFile = <ThrowOnError extends boolean = false>(options: Options<DownloadFileData, ThrowOnError>) => (options.client ?? client).get<DownloadFileResponses, DownloadFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/files/{file_id}',
    ...options
});

/**
 * List Batches
 */
export const listBatches = <ThrowOnError extends boolean = false>(options?: Options<ListBatchesData, ThrowOnError>) => (options?.client ?? client).get<ListBatchesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/agents/batches',
    ...options
});

/**
 * Health
 */
export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>) => (options?.client ?? client).get<HealthResponses, unknown, ThrowOnError>({ url: '/health', ...options });
